import { type FundingModel, FundingType } from '@bytel/leviator';

import { formatPrice } from '@helpers/wording';

function formatDurationDescription(durations: number[]): string {
    const uniqueDurations = [...new Set(durations)].sort((a, b) => a - b);
    if (uniqueDurations.length === 1) {
        return `Le reste en ${uniqueDurations[0]} mois`;
    }
    if (uniqueDurations.length === 2) {
        return `Le reste en ${uniqueDurations[0]} ou ${uniqueDurations[1]} mois`;
    }
    const lastDuration = uniqueDurations.at(-1);
    const otherDurations = uniqueDurations.slice(0, -1).join(', ');
    return `Le reste en ${otherDurations} ou ${lastDuration} mois`;
}

export function getFundingDescription(funding: FundingModel, options: FundingModel[]): string | null {
    switch (funding.type) {
        case FundingType.COMPTANT:
            return 'En une seule fois';
        case FundingType.YOUNITED:
        case FundingType.SWAPPY: {
            const durations = options
                .map((f) => f.installments)
                .filter((d): d is number => d !== undefined)
                .toSorted((a, b) => a - b);
            return formatDurationDescription(durations);
        }
        case FundingType.EDP:
            return `+ ${formatPrice(funding.monthlyAmount)}/mois pendant ${funding.installments ?? 0} mois ${funding.interestAmount > 0 ? 'avec frais' : 'à 0%'}`;
        default:
            return null;
    }
}
